import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { getUser } from '../../actions/session';
import { GET_ALL_ACCOUNTS, INVOICE_DOWNLOAD_API, CREATE_RESTRICTION, INVOICE_LIST_API } from '../../config/rest_endpoints';
import CustomLoader from '../common/loader';
import DatePicker from "react-datepicker";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import setSeconds from "date-fns/setSeconds";
import { RC_LOAD_LOGIN } from '../routers/RouteConstants';
import { Notifications } from '../common/notification';
import { withRouter } from 'react-router';
import Select from 'react-select';
import Pagination from "react-js-pagination"
import { fmtDollar4, fmtMins } from '../common/formatters';

// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";

const getLastBillingDate = () => {
    const today = moment().utc().startOf('day');
    const candidates = [];

    // Last Sunday (weekly invoice createDate = end of billing period = Sunday)
    if (today.day() === 0) {
        candidates.push(today.clone());
    } else {
        candidates.push(today.clone().subtract(today.day(), 'days'));
    }

    // 15th of current month if on or before today
    const fifteenth = today.clone().startOf('month').date(15);
    if (fifteenth.isSameOrBefore(today)) {
        candidates.push(fifteenth);
    }
    // 15th of previous month
    candidates.push(today.clone().subtract(1, 'month').startOf('month').date(15));

    // Last day of previous month
    candidates.push(today.clone().subtract(1, 'month').endOf('month').startOf('day'));

    // Last day of current month if today is that day
    const lastDayThisMonth = today.clone().endOf('month').startOf('day');
    if (lastDayThisMonth.isSameOrBefore(today)) {
        candidates.push(lastDayThisMonth);
    }

    // Return the most recent one
    let mostRecent = candidates[0];
    candidates.forEach((d) => {
        if (d.isSameOrBefore(today) && d.isAfter(mostRecent)) {
            mostRecent = d;
        }
    });
    return mostRecent;
};

const InvoiceTable = (props) => {

    const strDate = getLastBillingDate().toDate();
    const enDate = moment().utc().startOf('day').toDate();

    const [tableData, setTableData] = useState([])
    const [userInfo] = useState(getUser())
    const [isGetting, setIsGetting] = useState(false)
    const [isExpire, setisExpire] = useState(false)
    const [startDate, setStartDate] = useState(strDate)
    const [endDate, setEndDate] = useState(enDate)
    const [accountOption, setAccountOption] = useState([])
    const [accountSelect, setAccountSelect] = useState('')
    const [isChecked, setisChecked] = useState(true)
    const [activePages, setActivePages] = useState(1)
    const [totalCount,setTotalCount] = useState(null)
    const [itemCounts, setItemCounts] = useState({ label: '10', value: 10 })
    const [countList] = useState([
        { label: '10', value: 10 },
        { label: '15', value: 15 },
        { label: '25', value: 25 },
        { label: '50', value: 50 },
        { label: 'All', value: 400 },
    ])
    const [isBtnSpin, setisBtnSpin] = useState(false);
    const [isDownLoadSpin, setisDownLoadSpin] = useState(false);

    useEffect(() => {
        getInvoiceList()
        getAccountList()
        
    }, [activePages])

    useEffect(() => {
        getInvoiceList()
        setisBtnSpin(false)
    }, [itemCounts])

    const handleDate = (date, value) => {
        if (value == "start") {
            setStartDate(date)
        } else {
            setEndDate(date)
        }
    }

    const handleSelectPagination = (itemCounts) => {
        setItemCounts(itemCounts)
    }

    const handleChecked = () => {
        setisChecked(!isChecked)
    }

  
    const handleAccountSelect = (accountSelect) => {
        setAccountSelect(accountSelect)
    }

    const getAccountList = () => {
        let User = userInfo
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(GET_ALL_ACCOUNTS, { headers }).then(res => {
            if (res) {
                let resp = res.data.data
                let getOption = resp.map((row) => {
                    row['label'] = row['accountName']
                    row['value'] = row['id']
                    return row
                })
                setAccountOption(getOption)
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
        })
    }

    const handlePageNumber = (pageNumber) => {
        setActivePages(pageNumber)
    }

    const getInvoiceList = () => {
        let User = userInfo
        var headers = { "Authorization": "Bearer " + User.token };
        var payload = {
            // "startDate": startDate.toLocaleString(),
            // "endDate": endDate.toLocaleString()
            "startDate": moment(startDate).format('MM/DD/YYYY, h:mm:ss A'),
            "endDate": moment(endDate).format('MM/DD/YYYY, h:mm:ss A')
        }
        let accountId = accountSelect === null ? undefined :accountSelect.value
        setIsGetting(true)
        setisBtnSpin(true)
        Axios.post(`${INVOICE_LIST_API}?accountID=${accountId}&excludeZero=${isChecked ? 'yes' : 'no'}&page=${activePages}&search=&limit=${itemCounts.value}`, payload, { headers }).then(res => {
            if (res) {
                let resp = res.data.data
                setTableData(resp)
                setIsGetting(false)
                setisBtnSpin(false)
                setTotalCount(res.data.pageinfo.totalCount)
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                setisExpire(true)
                localStorage.removeItem('user');
                props.history.push(RC_LOAD_LOGIN);
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            setIsGetting(false)
            setisBtnSpin(false)

        })
    }

    const onDonwload = (data) => {
        // http://207.38.67.31:8080/invoice/6101874631813750e8e9b44d-000001.pdf  --- reference
        // http://207.38.67.31:8080/apiv1/invoice/61c1d30580ed4535d6a261d8-6101874631813750e8e9b44d-000001.pdf  --- reference
        const invoiceName = data.invoiceName
        const url = `${INVOICE_DOWNLOAD_API}/${invoiceName}`
        window.open(url, '_blank')

    }

    const renderTableData = () => {
        if (tableData === null || tableData.length === 0) {
            return (
                <div className=" ml-3">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else {
            return tableData.map((row, idx) => {
                return (<tr key={idx}>
                    <td>{row['accountName']}</td>
                    <td>{row['createDate']}</td>
                    <td>{row['frequency']}</td>
                    <td>{row['dateRange']}</td>
                    <td>{row['invoiceNumber']}</td>
                    <td style={{textAlign:'right'}}>{fmtMins(row['outboundMinutes'])}</td>
                    <td style={{textAlign:'right'}}>{fmtDollar4(row['outboundCost'])}</td>
                    <td style={{textAlign:'right'}}>{fmtDollar4(row['totalAmount'])}</td>
                    <td><button type="button" class=" main-button btn btn-success btn-icon border-2 ml-2" onClick={onDonwload.bind(this, row)} ><i class={'icon-file-pdf'}></i></button></td>
                </tr>)
            })
        }
    }


    return (
        <div>
            <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                    <h5 style={{fontWeight:'600',fontSize:'14px',color:'#0F172A',margin:0}}>Invoice List</h5>
                    <div style={{width:'9em'}}>
                        <Select
                            value={itemCounts}
                            onChange={handleSelectPagination}
                            options={countList}
                            placeholder="Select item count"
                        />
                    </div>
                </div>
                <div style={{background:'#F8FAFC',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                    <div style={{display:'flex',flexWrap:'wrap',gap:'16px',alignItems:'flex-end'}}>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>Start Date <span style={{color:'#94A3B8',fontSize:'11px'}}>UTC</span></label>
                            <DateRangePicker
                                onCallback={(date) => handleDate(date, "start")}
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(startDate),
                                    locale: { format: 'MMMM/DD/YYYY' },
                                }}
                            >
                                <input type="text" className="form-control" style={{minWidth:'220px',borderRadius:'8px',border:'1px solid #E2E8F0',fontSize:'13px'}} />
                            </DateRangePicker>
                        </div>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>End Date <span style={{color:'#94A3B8',fontSize:'11px'}}>UTC</span></label>
                            <DateRangePicker
                                onCallback={(date) => handleDate(date, "end")}
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(endDate),
                                    locale: { format: 'MMMM/DD/YYYY' },
                                }}
                            >
                                <input type="text" className="form-control" style={{minWidth:'220px',borderRadius:'8px',border:'1px solid #E2E8F0',fontSize:'13px'}} />
                            </DateRangePicker>
                        </div>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>Account</label>
                            <div style={{minWidth:'220px'}}>
                                <Select
                                    value={accountSelect}
                                    onChange={handleAccountSelect}
                                    options={accountOption}
                                    isClearable
                                    placeholder="Select Account"
                                />
                            </div>
                        </div>
                        <div style={{display:'flex',alignItems:'center',gap:'8px',paddingBottom:'4px'}}>
                            <input type="checkbox" onChange={handleChecked} checked={isChecked} style={{width:'16px',height:'16px',accentColor:'#10B981'}} />
                            <span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Exclude $0.00</span>
                        </div>
                        <button type="button" onClick={getInvoiceList} style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#fff',border:'none',borderRadius:'10px',padding:'8px 20px',fontSize:'13px',fontWeight:'500',cursor:'pointer',boxShadow:'0 2px 8px rgba(16,185,129,0.25)',marginLeft:'auto'}}>
                            Generate <i className={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-arrow-right8'} ml-2`}></i>
                        </button>
                    </div>
                </div>
                <div style={{overflowX:'auto',overflowY:'auto',maxHeight:'56em'}}>
                    <table className="table table-striped" style={{margin:0}}>
                        <thead>
                            <tr>
                                <th>Account</th>
                                <th>Create Date</th>
                                <th>Frequency</th>
                                <th>Date Range</th>
                                <th>Invoice Number</th>
                                <th style={{textAlign:'right'}}>Outbound Minutes</th>
                                <th style={{textAlign:'right'}}>Outbound Cost</th>
                                <th style={{textAlign:'right'}}>Total Cost</th>
                                <th>Download Report</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isGetting ? <CustomLoader /> : renderTableData()}
                        </tbody>
                    </table>
                </div>
                <div style={{padding:'12px 20px',borderTop:'1px solid #F1F5F9',textAlign:'center'}}>
                    <Pagination
                        activePage={activePages}
                        itemsCountPerPage={itemCounts.value}
                        totalItemsCount={totalCount}
                        pageRangeDisplayed={5}
                        onChange={handlePageNumber}
                    />
                </div>
            </div>
        </div>
    )
}

export default withRouter(InvoiceTable)